import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0093',
    ecrans: ['00-2'],
    params: ['el1cleint']
});
